import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import slugify from "slugify";

function CategoryMenu(props) {
  const { type = 1 } = props;

  return (
    <div className="dropdown category-dropdown">
      <Link
        to={`/collections`}
        className="dropdown-toggle"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-display="static"
        title="Browse Categories"
      >
        Browse Collection
        {type === 3 ? <i className="icon-angle-down"></i> : ""}
      </Link>

      <div className="dropdown-menu">
        <nav className="side-nav">
          <ul className="menu-vertical sf-arrows">
            <li className="item-lead">
              <Link to="/collections">All Categories</Link>
            </li>
            <li className="item-lead">
              <Link to="/allcollection">All Products</Link>
            </li>
          

            <StaticQuery
              query={query}
              render={({ allCategories }) => {
                let categories = allCategories.nodes.filter(
                  (c) => c._id !== "1"
                );
                return categories.map(({ name,itemCount,seoMetaData, subCategories }, i) => {
                
                  const path = `/collections/${seoMetaData?.slug||slugify(name).toLowerCase()}/`;
                  return (
                    <li key={`cat-${i}`}>
                      <Link to={path}>
                        {name}{" "}{itemCount}
                        {subCategories.length > 0 && (
                          <span className="sub-arrow"></span>
                        )}
                      </Link>
                      {subCategories.length > 0 && (
                        <ul>
                          {subCategories.map((subcat, j) => {
                            const subpath = `${path}${subcat?.seoMetaData?.slug||slugify(
                              subcat.name
                            ).toLowerCase()}/`;
                            return (
                              <li key={`subcat-${j}`}>
                                <Link to={subpath}>{subcat.name}</Link>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                });
              }}
            />
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default React.memo(CategoryMenu);

const query = graphql`
  {
      allCategories {
      nodes{
        _id
        name
        seoMetaData{
          slug
        }
        subCategories {
          name
          seoMetaData{
            slug
          }
        }
      }
      }
    
  }
`;
